import React from 'react'
import agent from '../agent'
import TaskList from './widgets/TaskList'
import { connect } from 'react-redux'
import Pager from 'react-pager'
import { DatePicker } from 'antd';
import 'antd/dist/antd.css';
import moment from 'moment';
import { Link } from 'react-router-dom';
import {
  TASK_VERIFICATION_LOADED,
  TASK_VERIFICATION_NEXT_PAGE_LOADED,
  TASK_VERIFICATION_UNLOADED,
  TASK_VERIFICATION_EXPORT,
  TASK_VERIFICATION_SEARCH_LOADED,
  UPDATE_FIELD_TASK_SEARCHTERM,
  CHANGE_DATE_STRINGS
} from '../constants/actionTypes'
const { RangePicker } = DatePicker;
const dateFormat = 'YYYY/MM/DD';

const mapStateToProps = state => ({
  ...state.task,
  appName: state.common.appName,
  token: state.common.token,
  csvData: state.task.csvData,
  date_from: state.common.date_from,
  date_to: state.common.date_to
});

const mapDispatchToProps = dispatch => ({
  onLoad: (payload, status, pageIndex, terms, date_from, date_to) =>
    dispatch({ type: TASK_VERIFICATION_LOADED, payload, status, currentPage: pageIndex, searchTerm: terms, date_from, date_to }),
  onLoadNextPage: (payload, status, pageIndex, terms, date_from, date_to) => {
    dispatch({ type: TASK_VERIFICATION_NEXT_PAGE_LOADED, payload, status, currentPage: pageIndex, searchTerm: terms, date_from, date_to })
  },
  onSearch: (payload, status, pageIndex, terms, date_from, date_to) => {
    dispatch({ type: TASK_VERIFICATION_SEARCH_LOADED, payload, status, currentPage: pageIndex, searchTerm: terms, date_from, date_to })
  },
  onChangeSearchTerm: value =>
    dispatch({ type: UPDATE_FIELD_TASK_SEARCHTERM, key: 'searchTerm', value }),
  onChangeDateStrings: (date_from, date_to) =>
    dispatch({ type: CHANGE_DATE_STRINGS, date_from, date_to }),
  onUnload: () =>
    dispatch({ type: TASK_VERIFICATION_UNLOADED }),
  onExportCsv: (payload) =>
    dispatch({ type: TASK_VERIFICATION_EXPORT, payload }),
});

class BankVerification extends React.Component {
  constructor() {
    super()
    this.exportCsv = () => ev => {
      ev.preventDefault()
      this.props.onExportCsv(agent.Tasks.export('User.Bank', 'Verify'))
    }
    this.changeSearchTerm = (ev) => this.props.onChangeSearchTerm(ev.target.value)

    this.handleAllSelected = this.handleChangeStatus.bind(this, 'all')
    this.handleNotverifiedSelected = this.handleChangeStatus.bind(this, 'notverified')
    this.handleCompletedSelected = this.handleChangeStatus.bind(this, 'completed')
    this.handleRejectedSelected = this.handleChangeStatus.bind(this, 'rejected')

    this.search = () => ev => {
      ev.preventDefault()
      const pageIndex = 1;
      const terms = this.props.searchTerm || ''
      const date_from = this.props.date_from || ''
      const date_to = this.props.date_to || ''
      const status = this.props.status || 'all'
      const payload = agent.Tasks.list('User.Bank', 'Verify', status, pageIndex, terms, date_from, date_to)
      this.props.onSearch(payload, status, pageIndex, terms, date_from, date_to)
    }
  }
  componentWillMount() {
    const pageIndex = 1;
    const terms = ''
    const date_from = ''
    const date_to = ''
    const status = 'all'
    this.props.onLoad(agent.Tasks.list('User.Bank', 'Verify', status, pageIndex, terms, date_from, date_to), status, pageIndex, terms, date_from, date_to);

  }
  componentWillReceiveProps(nextProps) {
    if (nextProps.csvData) {
      var data = new Blob([nextProps.csvData], { type: 'text/csv' });
      var csvURL = window.URL.createObjectURL(data);
      var tempLink = document.createElement('a');
      tempLink.href = csvURL;
      tempLink.setAttribute('download', `${new Date()}_tasks.csv`);
      tempLink.click();
    }
  }
  componentWillUnmount() {
    this.props.onUnload();
  }
  handlePageChanged(newPage) {
    const pageIndex = newPage + 1;
    const terms = this.props.searchTerm || ''
    const date_from = this.props.date_from || ''
    const date_to = this.props.date_to || ''
    const status = this.props.status || ''

    this.props.onLoadNextPage(agent.Tasks.list('User.Bank', 'Verify', status, pageIndex, terms, date_from, date_to), status, pageIndex, terms, date_from, date_to);
  }
  handleChangeStatus(tasksSatus) {
    const pageIndex = 1;
    const terms = this.props.searchTerm || ''
    const status = tasksSatus || ''
    const date_from = this.props.date_from || ''
    const date_to = this.props.date_to || ''

    const payload = agent.Tasks.list('User.Bank', 'Verify', status, pageIndex, terms, date_from, date_to)
    this.props.onLoad(payload, status, pageIndex, terms, date_from, date_to);
  }
  handleChangeDateStrings(dates, dateStrings) {
    var unixFrom = dateStrings[0] ? moment(dateStrings[0]).format('X') : ''
    var unixTo = dateStrings[1] ? moment(moment(dateStrings[1]).format('YYYY-MM-DD 23:59:59')).format('X') : ''
    this.props.onChangeDateStrings(unixFrom, unixTo)
  }
  render() {
    const date_from = this.props.date_from ? moment(moment(this.props.date_from * 1000).format('YYYY-MM-DD')) : ''
    const date_to = this.props.date_to ? moment(moment(this.props.date_to * 1000).format('YYYY-MM-DD')) : ''

    return (
      <div class='pane'>
        <Link className="buttonTop" to='#'><i className="icon ion-ios-download-outline" onClick={this.exportCsv()} ></i></Link>
        <h1>Bank Verifications</h1>
        <div className="filters">
          <div className="filterTabs">
            <Link to='/tasks/verification' className={this.props.status === 'all' ? "selected" : ""} value='all' onClick={this.handleAllSelected}>All</Link>
            <Link to='/tasks/verification?status=notverified' className={this.props.status === 'notverified' ? "selected" : ""} onClick={this.handleNotverifiedSelected}>Not verified</Link>
            <Link to='/tasks/verification?status=completed' className={this.props.status === 'completed' ? "selected" : ""} onClick={this.handleCompletedSelected}>Completed</Link>
            <Link to='/tasks/verification?status=rejected' className={this.props.status === 'rejected' ? "selected" : ""} onClick={this.handleRejectedSelected}>Rejected</Link>
          </div>
          <div className="filterSearch">
            <RangePicker
              ranges={{ 'This Month': [moment().startOf('month'), moment()], Today: [moment(), moment()] }}
              value={[date_from, date_to]}
              onChange={this.handleChangeDateStrings.bind(this)}
            />
            <input type="text" placeholder="find by key/user email" value={this.props.searchTerm} onChange={this.changeSearchTerm} />
            <button type="submit" onClick={this.search()}>Find</button>
          </div>
        </div>
        <TaskList tasks={this.props.verifications} type='bank' loading={this.props.loading} />
        {
          this.props.verifications && this.props.verifications.length > 0 ?
            <Pager
              total={this.props.totalPage || 0}
              current={this.props.currentPage - 1}
              visiblePages={7}
              titles={{ first: '<<', last: '>>' }}
              onPageChanged={this.handlePageChanged.bind(this)}
            />
            : null
        }
      </div>
    );
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(BankVerification);



// WEBPACK FOOTER //
// ./src/components/BankVerification.js